import { render, staticRenderFns } from "./AddWheatReceivedModal.vue?vue&type=template&id=90f8d042&"
import script from "./AddWheatReceivedModal.vue?vue&type=script&lang=js&"
export * from "./AddWheatReceivedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports